export { default } from './isHostComponent';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/isHostComponent/index.js
// module id = 167
// module chunks = 25